<template>
  <div class="index_wrapper" id="page" :class="{pd:useract}">
    <div class="gyzhsb_top_outer" :class="{bgc:scroll>10}">
      <div class="gyzhsb_top">
        <div class="left_logo_outer">
          <img :src="imgUrl+'gyzh_qyfw_logo.png'"/>
        </div>
        <div class="mid_tab_outer">
          <span v-for="(item,index) in topList" :key="index" class="item" :class="{'active':cur==index}"
                @click="navTo(index)">{{ item }}</span>
        </div>
        <div class="right_btn_outer">
          <span class="cloudicon ci_search" @click="drawer = true"></span>
          <div class="right_login_btn_outer" @click="toUser">
          	<span class="cloudicon ci_user_solid"  :class="{'active':$store.state.scn!='登录'}" ></span>
          	<span class="txt">{{$store.state.scn}}</span>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <div class="gyzhsb_btm_outer">
      <div class="gyzhsb_btm">
        <div>
          <div>
            <img :src="imgUrl+'gyzh_qyfw_logo2.png'" width="230px"/>
          </div>
          <div class="left_list">
            <div class="col">
              <div v-for="(item,index) in btmList" :key="index" v-if="index<3" @click="btmLinkTo(item,index)" class="item">{{ item.t }}</div>
            </div>
            <div class="col">
              <div v-for="(item,index) in btmList" :key="index" v-if="index>2" @click="btmLinkTo(item,index)" class="item">{{ item.t }}</div>
            </div>
          </div>
        </div>
        <div class="right_info_outer">
          <div style="display:flex;justify-content:flex-end">
            <div style="margin-right:108px"><img :src="imgUrl+'mp_code1.svg'" width="108px" style="border-radius:10px;" /><p style="text-align:center">园区微信公众号</p></div>
            <div><img :src="imgUrl+'mp_code2.jpg'" width="108px" style="border-radius:10px;" /><p style="text-align:center">企业服务小程序</p></div>
          </div>
          <div class="right_info">
            <p>主办单位：上海市工业综合开发区</p>
            <p>© {{ year }} 上海市工业综合开发区企业服务平台  </p>
            <p>沪ICP备160211835号-1&nbsp;&nbsp;&nbsp;&nbsp;<img :src="imgUrl+'indextext10.jpg'" style="position: relative;top: 3px;height: 16px">&nbsp;
              沪公网安备31263719002391号
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-drawer
      title="我是标题"
      :visible.sync="drawer"
      :direction="direction"
      :with-header="false">
      <!--:before-close="handleClose"-->
      <div class="drawer_cont_outer">
        <div class="dc_title">
          <!--<div @click="drawer = false" style="position: absolute;left:10px;top: 4px;border-radius: 50%;border:1px solid #ddd">-->
            <!--<img :src="imgUrl+'arrow_right.png'" width="22px"/>-->
            <!--<span class="cloudicon ci_unvalid" style="font-size: 22px;"></span>-->
          <!--</div>-->
          <div class="input_outer">
            <el-input class="input_el" v-model="inputVal" @keyup.enter.native="searchNts" autocomplete="off"></el-input>
          </div>
          <span class="cloudicon ci_search" @click="searchNts"></span>

        </div>
        <div class="dc_cont">
          <div class="result_lab">
            <div v-for="(item,index) in keyData" :key="index" class="item" :class="{'active':index==labcur}"
                 @click="changelab(item.cate,index)">
              {{ item.name }}({{ item.total }})
            </div>
          </div>
          <div class="result_cont">
            <div  @click="viewItem(item)" class="item" v-for="(item,index) in resData"
                 :key="item.id">
              <div>
                {{ item.post_title }}
              </div>
              <div class="btm_time">
                {{ item.published_time }}
              </div>
            </div>
          </div>
        </div>
        <!--	<el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="pagesize"
          :total="1000"
          @current-change="handleCurrentChange">
        </el-pagination>-->
      </div>
    </el-drawer>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="980px"
    >

      <div class="login_panel">
        <div class="panel_left">
          <img :src="imgUrl+'login_img.png'"/>
          <div class="tips">说明：系统用户由管理员统一分配产生</div>
        </div>
        <div class="panel_right">
          <div class="h">用户登录</div>
          <div class="login_item">
            <el-input placeholder="手机号/用户名" v-model="uname" maxlength="18"></el-input>
          </div>
          <div class="login_item">
            <el-input type="password" placeholder="密码" v-model="psword"></el-input>
          </div>
          <div class="login_item">
            <el-input placeholder="验证码" v-model="piccode" maxlength="6"></el-input>
            <div class="img_outer"><img height="40px" @click="changeImgCode" :src="validUrl"/></div>
          </div>
          <label class="login_item2">
            <el-checkbox></el-checkbox>&nbsp;记住登录信息</label>
          <div class="login_item login_btn" @click="pwLogin">
            <el-button type="primary">登录</el-button>
          </div>
          <div class="login_change" @click="loginChange">手机验证码登录</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisibleYzm"
      width="980px"
    >

      <div class="login_panel">
        <div class="panel_left">
          <img :src="imgUrl+'login_img.png'"/>
          <div class="tips">说明：系统用户由管理员统一分配产生</div>
        </div>
        <div class="panel_right">
          <div class="h">用户登录</div>
          <div class="login_item">
            <el-input placeholder="手机号" v-model="uname2" maxlength="11"></el-input>
            <div class="yzm">
              <span class="send_yzm" :class="{send_yzm2:sendBtn==1}" @click="sendYzm()"
                    v-show="SendYzmSpan==0">{{ sendBtnTxt }}</span>
              <span class="send_again" v-show="SendYzmSpan==1">{{ sendAgainTip }}</span>
            </div>
          </div>
          <div class="login_item">
            <el-input placeholder="短信验证码" maxlength="6" v-model="messcode"></el-input>
          </div>
          <div class="login_item login_btn" @click="messLogin">
            <el-button type="primary">登录</el-button>
          </div>
          <div class="login_change" @click="loginChange2">密码登录</div>
        </div>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import Qs from 'qs'

export default {
  name: 'index',
  data() {
    return {
      validUrl:this.bUrl+"/new_captcha?100",
      inputVal: '',
      drawer: false,
      direction: 'rtl',
      currentPage: 3,
      pagesize: 10,
      cur: null,
      labcur: 0,
      year: '2020',
      topList: ['首页', '申报通知', '惠企政策', '企业橱窗'],
      btmList: [{t:'申报通知',n:'/notice'}, {t:'惠企政策',n:'/policy'}, {t:'企业橱窗',n:'/bshow'}, {t:'专项资金申请',n:'/notice'}, {t:'我有诉求',n:'/userappeal'}, {t:'数据调查',n:'/usersurvey'}, {t:'企业走访',n:'/uservisit'}],
      labData: ['全部', '申报通知', '惠企政策', '企业橱窗'],
      resData: [],
      totalData:[],
      rarr: [['homepage'], ['notice', 'notilist', 'notidetail', 'declare', 'declare2'], ['policy', 'polidetail'], ['bshow', 'bsdetail']],
      useract: false,
      scroll: 0,
      dialogVisible: false,
      dialogVisibleYzm: false,
      uname: '',
      psword: '',
      piccode: '',
      uname2: '',
      messcode: '',
      SendYzmSpan: 0,
      sendAgainTip: '59秒后重新发送',
      sendBtn: 0,
      sendBtnTxt: '发送验证码',
      keyData: [
        {name: '全部', total: 0, cate: -1},
        {name: '申报通知', total: 0, cate: 1},
        {name: '惠企政策', total: 0, cate: 4},
        {name: '企业橱窗', total: 0, cate: 2}
      ]
    }
  },
  created() {
  	let _this = this
    let _year = new Date()
    this.year = _year.getFullYear()
    this.navChange(this.$route.name)
    window.scrollTo(0,0)
  },
  mounted() {
    window.addEventListener('scroll', this.pageScroll)
  },
  watch: {
    SendYzmSpan: function (val) {
      if (val == 1) {
        var i = 59;
        var id1 = setInterval(function () {
          i--;
          this.sendAgainTip = i + '秒后重新发送';
          if (i < 1) {
            clearInterval(id1);
            this.SendYzmSpan = 0;
            this.sendAgainTip = '59秒后重新发送';
            this.sendBtnTxt = '重新发送';
          }
        }.bind(this), 1000);
      }
    },
    $route(to, from) {
      this.scroll = 0;
      this.navChange(to.name)
      let _this = this
      if (to.name.indexOf('user') < 0) {
        window.scrollTo(0, 0);
      } else if (from.name.indexOf('user') < 0) {
        window.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 200);
        this.scroll = 200;
      }
      if(to.name=='homepage'&&this.$route.query.loginto){
      	setTimeout(function(){
	    		_this.dialogVisible = true
	    	},300)
      }
    }
  },
  methods: {
    changeImgCode() {
      var num=Math.ceil(Math.random()*10);//生成一个随机数（防止缓存）
      this.validUrl = this.bUrl+"/new_captcha?" + num;
    },
    navTo(index) {
      this.cur = index
      if (index == 0) {
        this.$router.push({name: 'homepage'})
      }
      if (index == 1) {
        this.$router.push({path: '/notice'})
      } else if (index == 2) {
        this.$router.push({name: 'policy'})
      } else if (index == 3) {
        this.$router.push({name: 'bshow'})
      }
    },

    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    toUser() {
      let gyzhqyToken = window.localStorage.getItem('gyzhqy_token')
      if (gyzhqyToken) {
        this.$ajax.get(this.bUrl + 'api/portal/user/getCorpInfo')
          .then(function (res) {
            if (res.data.code == 200) {
              this.$router.push({path: '/user'})
            } else {
              window.localStorage.setItem('gyzhqy_token', '')
              this.dialogVisible = true
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.dialogVisible = true
      }
//	        	this.dialogVisible = true
//	        	this.$router.push({path:'/user'})
    },
    navChange(n) {
      if (n.indexOf('user') > -1) {
        this.useract = true;
        this.cur = null
      } else {
        this.rarr.forEach(function (item, index) {
          if (item.indexOf(n) > -1) {
            this.cur = index;
          }
        }, this)
        this.useract = false;
      }
    },
    pageScroll() {
      this.scroll = window.scrollY;
    },
    loginChange() {
      this.dialogVisibleYzm = true;
      this.dialogVisible = false;
    },
    loginChange2() {
      this.dialogVisible = true;
      this.dialogVisibleYzm = false;
    },
    pwLogin() {
      var uname = this.uname, psword = this.psword ,valid_code=this.piccode;
      if (uname && psword && valid_code) {
        var data = Qs.stringify({'username': uname, 'password': psword,'valid_code':valid_code});
        this.$ajax.post(this.bUrl + 'api/user/public/login', data).then(function (res) {
            if (res.data.code == 200) {
              this.$message(res.data.msg);
              this.$store.commit('mcn',res.data.data.user.username);
              window.localStorage.setItem("gyzhqy_token", res.data.data.token);
              window.localStorage.setItem("gyzhqy_user_info", JSON.stringify(res.data.data.user));
             // this.getCorpInfo();
              this.$router.push({path: '/user'})
              this.dialogVisible = false
            } else {
              this.$message.error(res.data.msg);
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.$message.error('请输入正确信息');
      }

    },
    messLogin() {
      var uname2 = this.uname2, messcode = this.messcode;
      if (uname2 && messcode) {
        var data = Qs.stringify({'mobile': uname2, 'code': messcode});
        this.$ajax.post(this.bUrl + 'api/user/public/smslogin', data, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'XX-Device-Type': 'web'
          }
        })

          .then(function (res) {
            if (res.data.code == 200) {
              this.$message(res.data.msg);
              this.$store.commit('mcn',res.data.data.user.username);
              window.localStorage.setItem("gyzhqy_token", res.data.data.token);
              window.localStorage.setItem("gyzhqy_user_info", JSON.stringify(res.data.data.user));
              this.$router.push({path: '/user'})
              this.dialogVisibleYzm = false
            } else {
              this.$message.error(res.data.msg);
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.$message.error('请输入正确信息');
      }

    },
    sendYzm() {
      if (this.uname2.length == 11) {
        this.SendYzmSpan = 1;
        var _phone = this.uname2;
        var data = Qs.stringify({'username': _phone});
        this.$ajax.post(this.bUrl + '/api/home/index/sendcode', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then(function (res) {
            if (res.data.code == 200) {
              this.$message(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          }.bind(this))
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.$message.error('手机号输入不正确');
      }
    },
    async getCorpInfo() {
      let res01 = await this.$ajax.get(this.bUrl + 'api/portal/user/getCorpInfo');
      window.localStorage.setItem("gyzhqy_corp_info", JSON.stringify(res01.data.data))
      let res02 = await this.$ajax.get(this.bUrl + 'api/portal/user/tags');
      window.localStorage.setItem("gyzhqy_corp_tag", JSON.stringify(res02.data.data))
    },
    async searchNts() {
      let res01 = await this.$ajax.get(this.bUrl + 'api/portal/lists/search?keyword=' + this.inputVal);
      if (res01.data.code === 200) {
        let totalItem = res01.data.data.total;
        let listItem = res01.data.data.list;
        let keyData = [
          {name: '全部', total: listItem.length, cate: -1},
          {name: '申报通知', total: 0, cate: 1},
          {name: '惠企政策', total: 0, cate: 4},
          {name: '企业橱窗', total: 0, cate: 2}
        ];
        totalItem.forEach(item => {
          let cateId = item.category_id;
          keyData.forEach(entry => {
            if (cateId === entry.cate) {
              entry.total = item.total;
            }
          });
        })

        let n2 = totalItem.filter(item => item.category_id === 3);
        if (n2.length > 0) {
          let total = n2[0].total;
          keyData.forEach(entry => {
            if (entry.cate === 1) {
              entry.total += total;
            }
          });
        }
        this.keyData = keyData;
        this.labcur = 0;
        this.resData = listItem;
        this.totalData = listItem;
      } else {
        this.$message.error(res01.data.msg);
      }
    },
    changelab(cate, index) {

      this.labcur = index
      if (cate === -1) { // 全部
        this.resData = this.totalData;
      } else if (cate === 1) {
        this.resData = this.totalData.filter(item => (item.category_id === cate || item.category_id === 3));
      } else {
        this.resData = this.totalData.filter(item => item.category_id === cate);
      }
    },

    viewItem(item) {
      this.drawer = false;
      if (item.category_id === 1) { // 申报通知
        this.$router.push({name: 'notidetail', query: {id: item.id}})
      } else if (item.category_id === 3) { // 申报通知
        this.$router.push({name: 'notidetail', query: {id: item.id,type:'公告'}})
      } else if (item.category_id === 4) { //惠企政策
        this.$router.push({name: 'polidetail', query: {id: item.id}})
      } else if (item.category_id === 2) { //企业橱窗
        this.$router.push({name: 'bsdetail', query: {id: item.id}})
      }
    },
    btmLinkTo(item,index){
    	if(index<4){this.$router.push({path:item.n})}
    	else{
    		this.$ajax.get(this.bUrl + 'api/portal/user/getCorpInfo')
	      .then(function (res) {
	    	  if(res.data.code!=200){
		        this.$message.error(res.data.msg);
		      }else{
		      	if(item.t=='数据调查'){
		      		if(res.data.data.jjyx!=1){
								this.$router.push({path:'/usersurvey2'})
								return
							}
		      	}
		      	this.$router.push({path:item.n})
		      }
	      }.bind(this))
	      .catch(function (error) {
	        console.log(error);
	      });
    	}
    }
  }
}
</script>

<style scoped>
.index_wrapper {
  position: relative;
  padding-bottom: 800px;
  background: #fff url('/gyzhqyimgs/gyzhsb_btm_bg.png') no-repeat center calc(100% + 790px);
}

.index_wrapper.pd {
  padding-bottom: 416px;
  background: #fff url('/gyzhqyimgs/gyzhsb_btm_bg2.png') no-repeat center calc(100% + 10px);
}

.gyzhsb_top_outer {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.gyzhsb_top_outer.bgc {
  background: #fff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
}

.gyzhsb_top {
  width: 1180px;
  margin: 22px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mid_tab_outer {
  width: 770px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 18px;
}

.mid_tab_outer .item {
  cursor: pointer;
}

.mid_tab_outer .item.active {
  color: #399FFF;
}

.mid_tab_outer .item:hover {
  color: #399FFF;
}

.right_btn_outer {
	width: 220px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.right_btn_outer .cloudicon {
  font-size: 32px;
  cursor: pointer;
}

.ci_search {
  color: #4b4a4b;
}

.cloudicon:hover {
  color: #399FFF;
}
.ci_user_solid{
	font-size: 32px;
	width: 36px;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 100%;
	background: rgba(102,102,102,.1);
	color: rgba(0,0,0,.2);
	margin-left:-10px;
	margin-right: 10px;
}
.ci_user_solid.active {
  color: #fff;
  background: #0093FF;
}

.right_login_btn_outer{
	cursor: pointer;height: 40px;
	min-width: 120px;max-width: 160px;
	box-sizing: border-box;
	border-radius:20px;
	border:1px solid #E5E5E5;
	display: flex;
	align-items: center;
	padding:0 12px;
}
.right_login_btn_outer .txt{
	font-size: 14px;
	color: #0093FF;
  overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 100px;
}

.gyzhsb_btm_outer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.gyzhsb_btm {
  width: 1180px;
  margin: 22px auto;
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
}

.left_list {
  display: flex;
}

.left_list .col {
  padding-left: 96px;
}

.left_list .col .item {
  cursor: pointer;
}

.right_info_outer {
  padding-top: 25px;
  text-align: right;
}

.el-drawer.rtl {
  width: 520px !important;
}

.drawer_cont_outer {
  height: 100%;
  /*padding: 25px;*/
}

.dc_title {
  padding: 25px;
  height: 80px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(112, 112, 112, .2)
}

.dc_title .cloudicon {
  font-size: 30px;
  cursor: pointer;
}

.dc_title img {
  cursor: pointer;
}

.dc_title .input_outer {
  width: 100%;
  margin-right: 20px;
  margin-left: 6px;
}

.dc_title .input_outer .input_el {
  border-color: #4b4a4b !important;
}

.dc_cont {
  padding: 0 25px 25px 25px;
  height: calc(100% - 200px);
  overflow: auto;
  background: transparent url('/gyzhqyimgs/dc_bg.png') no-repeat center center;
}

.dc_cont .result_lab {
  height: 86px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.result_lab .item {
  padding: 12px 4px;
  border-bottom: 4px solid transparent;
  cursor: pointer;
}

.result_lab .item.active {
  border-bottom: 4px solid #3A9FFF;
}

.result_cont .item {
  height: 110px;
  position: relative;
  box-sizing: border-box;
  border-radius: 10px;
  background: #F0F5F8;
  border: 1px solid #E1EAFA;
  margin-bottom: 10px;
  padding: 20px;
}

.result_cont .btm_time {
  position: absolute;
  bottom: 20px;
}

.login_panel {
  display: flex;
  border-radius: 10px;
}

.panel_left {
  width: 487px;
  height: 518px;
  background: #EEF2F8;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.panel_left .tips {
  color: #6F88AF;
  margin-top: 100px;
}

.panel_right {
  width: 490px;
  box-sizing: border-box;
  padding: 50px 70px;
}

.panel_right .h {
  font-size: 26px;
  color: #6F88AF;
  margin-bottom: 26px;
}

.panel_right .login_item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
}

.login_item .yzm {
  position: absolute;
  right: 15px;
  top: 10px;
}

.login_item .yzm .send_yzm {
  color: #0093FF;
  cursor: pointer;
}

.login_item .yzm .send_again {
  color: #666;
}

.panel_right .img_outer {
  margin-left: 14px;
}

.panel_right .login_item2 {
  display: block;
  margin-bottom: 20px;
  cursor: pointer;
}

.login_change {
  margin-top: 30px;
  text-align: right;
  color: #0093FF;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/index.vue